export default "__VITE_ASSET__BRBfL7PU__"